/**
 * @file Album onboarding start landing page / schools.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../util/assets';
import {
  getAccountCheckoutGreetingName,
  getAccountUsername,
} from '../../../util/account';
import Button from '../../global/Button';
import OnboardingLayoutContentNarrow from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutContentNarrow';
import ContextualString from '../../contextual/ContextualString';
import { isPhotoFinderCreditsPPGDeliveryEnabled } from '../../../util/album-folder';
import { ALBUM_PRICE_MODE } from '../../../constants/albums';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func,
  isFreeJoin: PropTypes.func,
};

const OnboardingLandingSchools = ({
  albumFolder,
  onGetStarted,
  isFreeJoin,
}) => {
  const isPPA = albumFolder.album_price_mode === ALBUM_PRICE_MODE.PPA_ONLY;
  const isPPG = isPhotoFinderCreditsPPGDeliveryEnabled(albumFolder);
  const isPaid = isPPA || isPPG;
  const displayName = getAccountCheckoutGreetingName(albumFolder.account);
  const username = getAccountUsername(albumFolder.account);
  const displayNameComponent = (() => {
    if (username) {
      return (
        <a href={`/@${username}`} className="text-sm mb-2">
          By {displayName}
        </a>
      );
    }
    return <p className="text-sm">By {displayName}</p>;
  })();
  return (
    <OnboardingLayoutContentNarrow>
      <h4 className="mb-1 text-center">Welcome to</h4>
      <h2 className="text-black mb-1 text-center">{albumFolder.name}!</h2>

      {displayName && displayNameComponent}

      <p className="mb-0 text-center">
        {!isPaid && (
          <ContextualString
            id="albumDiscoveryEntryHeadline"
            type={albumFolder?.album_type}
            subtype={albumFolder?.album_subtype}
            values={{
              displayName,
            }}
          />
        )}
        {isPaid && (
          <ContextualString
            id="albumDiscoveryEntryHeadlinePaid"
            type={albumFolder?.album_type}
            subtype={albumFolder?.album_subtype}
            values={{
              displayName,
            }}
          />
        )}
        <br />
        <br />
        <ContextualString
          id="albumDiscoveryEntry"
          type={albumFolder?.album_type}
          subtype={albumFolder?.album_subtype}
        />
      </p>
      <img
        src={getAsset('/waldo-way.png')}
        height="140px"
        className="my-2"
        alt="Waldo Way"
      />
      <Button onClick={onGetStarted} className="mt-2" btnBlock>
        {isFreeJoin ? 'Join for FREE Today!' : "Let's Get Started!"}
      </Button>

      <div className="d-flex mt-1">
        <a href="/terms" target="_blank" className="m-auto text-xs">
          Terms of Use
        </a>
      </div>
    </OnboardingLayoutContentNarrow>
  );
};

OnboardingLandingSchools.propTypes = propTypes;

export default OnboardingLandingSchools;
